import type { EntityNames, Modules } from "../../config";
import type { InternalEnumNames } from "../localizationService";

export default class LocalizationService {
  get locale(): string {
    return "cs";
  }

  translateGeneral(code: string, size?: number) {
    return this.translate(`general.${code}`, size);
  }

  translateModule(module: Modules, code: string, size?: number) {
    return this.translate(`modules.${module}.${code}`, size);
  }

  translateEnum(enumName: InternalEnumNames, value: any, size?: number) {
    return this.translate(`enumeration.${enumName}.${value}`, size);
  }

  translateAttribute(model: EntityNames | string, attribute: string, size?: number): string {
    return this.translate(`attributes.${model}.${attribute}`, size);
  }

  formatDate(date?: Date | null, options?: Intl.DateTimeFormatOptions) {
    if (!date) {
      return "";
    }

    return date.toLocaleDateString("cs", options);
  }

  translate(code: string, size?: number) {
    return code;
  }
}
